import request from '@/utils/request'

// 查询商品编码列表
export function listExpress(query) {
  return request({
    url: '/server/conf/list',
    method: 'get',
    params: query
  })
}
// 查询商品编码列表
export function addExpress(data) {
  return request({
    url: '/server/conf/add',
    method: 'post',
    data: data
  })
}


// 查询商品编码列表
export function deleteExpress(expreConfIds) {
  return request({
    url: '/server/conf/delete/' + expreConfIds,
    method: 'post',
    data: {}
  })
}
